export default tag => (tag && tag.includes('<p>') ? 'div' : 'p');
